import { types } from "mobx-state-tree";
import { styleConstants as C } from "~/style/styleConstants";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export type UIStoreInstance = Instance<typeof UIStore>;
export type UIStoreSnapshotIn = SnapshotIn<typeof UIStore>;
export type UIStoreSnapshotOut = SnapshotOut<typeof UIStore>;

export const UIStore = types
  .model("UIStore", {
    safeAreaBackgroundColor: C.colorBackgroundTheme,
    clinicPhoneNumber: types.maybe(types.string),
  })
  .actions((self) => {
    return {
      setClinicPhoneNumber(clinicPhoneNumber: string) {
        self.clinicPhoneNumber = clinicPhoneNumber;
      },
    };
  });
